export default {
  loginType (state) {
    return state.loginType
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js